import type { CSSProperties } from "react";

interface TextSkeletonProps {
  className?: string;
  width?: CSSProperties["width"];
  height?: CSSProperties["height"];
}

const TextSkeleton = ({ className = "", height, width }: TextSkeletonProps) => {
  const sizeStyle: CSSProperties = { width, height };

  return (
    <div
      style={sizeStyle}
      className={`rounded-md overflow-hidden bg-gray-300 bg-[linear-gradient(90deg,#d1d5db_25%,#e5e7eb_37%,#d1d5db_63%)] bg-[length:200%_100%] bg-repeat-x animate-shimmer ${className}`}
    ></div>
  );
};

export default TextSkeleton;
